// 国家名称中英文映射表
const countryNameMap = {
    'United States': '美国',
    'China': '中国',
    'Japan': '日本',
    'South Korea': '韩国',
    'United Kingdom': '英国',
    'Germany': '德国',
    'France': '法国',
    'Canada': '加拿大',
    'Australia': '澳大利亚',
    'Russia': '俄罗斯',
    'India': '印度',
    'Brazil': '巴西',
    'Singapore': '新加坡',
    'Hong Kong': '香港',
    'Taiwan': '台湾',
    'Macao': '澳门',
    'Thailand': '泰国',
    'Malaysia': '马来西亚',
    'Indonesia': '印度尼西亚',
    'Philippines': '菲律宾',
    'Vietnam': '越南',
    'Netherlands': '荷兰',
    'Switzerland': '瑞士',
    'Sweden': '瑞典',
    'Norway': '挪威',
    'Denmark': '丹麦',
    'Finland': '芬兰',
    'Italy': '意大利',
    'Spain': '西班牙',
    'Portugal': '葡萄牙',
    'Austria': '奥地利',
    'Belgium': '比利时',
    'Ireland': '爱尔兰',
    'Poland': '波兰',
    'Czech Republic': '捷克',
    'Hungary': '匈牙利',
    'Greece': '希腊',
    'Turkey': '土耳其',
    'Israel': '以色列',
    'United Arab Emirates': '阿联酋',
    'Saudi Arabia': '沙特阿拉伯',
    'Egypt': '埃及',
    'South Africa': '南非',
    'Mexico': '墨西哥',
    'Argentina': '阿根廷',
    'Chile': '智利',
    'Colombia': '哥伦比亚',
    'Peru': '秘鲁',
    'New Zealand': '新西兰'
};

// 中国省份名称映射
const chinaProvinceMap = {
    'Beijing': '北京市',
    'Shanghai': '上海市',
    'Tianjin': '天津市',
    'Chongqing': '重庆市',
    'Guangdong': '广东省',
    'Jiangsu': '江苏省',
    'Shandong': '山东省',
    'Zhejiang': '浙江省',
    'Henan': '河南省',
    'Sichuan': '四川省',
    'Hubei': '湖北省',
    'Hunan': '湖南省',
    'Anhui': '安徽省',
    'Hebei': '河北省',
    'Jiangxi': '江西省',
    'Shanxi': '山西省',
    'Shaanxi': '陕西省',
    'Liaoning': '辽宁省',
    'Fujian': '福建省',
    'Yunnan': '云南省',
    'Guangxi': '广西壮族自治区',
    'Jilin': '吉林省',
    'Guizhou': '贵州省',
    'Heilongjiang': '黑龙江省',
    'Inner Mongolia': '内蒙古自治区',
    'Xinjiang': '新疆维吾尔自治区',
    'Gansu': '甘肃省',
    'Ningxia': '宁夏回族自治区',
    'Qinghai': '青海省',
    'Tibet': '西藏自治区',
    'Hainan': '海南省',
    'Hong Kong': '香港特别行政区',
    'Macao': '澳门特别行政区',
    'Taiwan': '台湾省'
};

// 城市名称映射
const cityNameMap = {
    // 中国城市
    // 直辖市
    'Beijing': '北京',
    'Shanghai': '上海',
    'Tianjin': '天津',
    'Chongqing': '重庆',

    // 省会城市
    'Shijiazhuang': '石家庄',
    'Taiyuan': '太原',
    'Hohhot': '呼和浩特',
    'Shenyang': '沈阳',
    'Changchun': '长春',
    'Harbin': '哈尔滨',
    'Nanjing': '南京',
    'Hangzhou': '杭州',
    'Hefei': '合肥',
    'Fuzhou': '福州',
    'Nanchang': '南昌',
    'Jinan': '济南',
    'Zhengzhou': '郑州',
    'Wuhan': '武汉',
    'Changsha': '长沙',
    'Guangzhou': '广州',
    'Nanning': '南宁',
    'Haikou': '海口',
    'Chengdu': '成都',
    'Guiyang': '贵阳',
    'Kunming': '昆明',
    'Lhasa': '拉萨',
    'Xian': '西安',
    'Lanzhou': '兰州',
    'Xining': '西宁',
    'Yinchuan': '银川',
    'Urumqi': '乌鲁木齐',

    // 副省级城市
    'Dalian': '大连',
    'Qingdao': '青岛',
    'Ningbo': '宁波',
    'Xiamen': '厦门',
    'Shenzhen': '深圳',

    // 重要地级市
    'Suzhou': '苏州',
    'Wuxi': '无锡',
    'Changzhou': '常州',
    'Nantong': '南通',
    'Yangzhou': '扬州',
    'Zhenjiang': '镇江',
    'Shaoxing': '绍兴',
    'Jinhua': '金华',
    'Wenzhou': '温州',
    'Zhuhai': '珠海',
    'Shantou': '汕头',
    'Foshan': '佛山',
    'Dongguan': '东莞',
    'Zhongshan': '中山',
    'Huizhou': '惠州',
    'Zhuzhou': '株洲',
    'Xiangtan': '湘潭',
    'Hengyang': '衡阳',
    'Yueyang': '岳阳',
    'Changde': '常德',
    'Shaoyang': '邵阳',
    'Yiyang': '益阳',
    'Loudi': '娄底',
    'Chenzhou': '郴州',
    'Yongzhou': '永州',
    'Huaihua': '怀化',
    'Xiangxi': '湘西',
    'Jingdezhen': '景德镇',
    'Pingxiang': '萍乡',
    'Jiujiang': '九江',
    'Xinyu': '新余',
    'Yingtan': '鹰潭',
    'Ganzhou': '赣州',
    'Ji\'an': '吉安',
    'Yichun': '宜春',
    'Fuzhou_JX': '抚州',
    'Shangrao': '上饶',
    'Jingzhou': '荆州',
    'Yichang': '宜昌',
    'Xiangyang': '襄阳',
    'Ezhou': '鄂州',
    'Jingmen': '荆门',
    'Xiaogan': '孝感',
    'Huanggang': '黄冈',
    'Xianning': '咸宁',
    'Suizhou': '随州',
    'Enshi': '恩施',
    'Xiantao': '仙桃',
    'Qianjiang': '潜江',
    'Tianmen': '天门',
    'Shennongjia': '神农架',

    // 重要县级市
    'Kunshan': '昆山',
    'Zhangjiagang': '张家港',
    'Changshu': '常熟',
    'Taicang': '太仓',
    'Jiangyin': '江阴',
    'Yixing': '宜兴',
    'Haimen': '海门',
    'Rugao': '如皋',
    'Qidong': '启东',
    'Hai\'an': '海安',
    'Dongtai': '东台',
    'Yancheng': '盐城',
    'Dafeng': '大丰',
    'Xinghua': '兴化',
    'Jingjiang': '靖江',
    'Taixing': '泰兴',
    'Jiangyan': '姜堰',
    'Gaoyou': '高邮',
    'Baoying': '宝应',
    'Yizheng': '仪征',
    'Danyang': '丹阳',
    'Jurong': '句容',
    'Yangzhong': '扬中',

    // 重要区
    'Xishan': '锡山',
    'Huishan': '惠山',
    'Binhu': '滨湖',
    'Liangxi': '梁溪',
    'Xinwu': '新吴',
    'Hanjiang': '邗江',
    'Jiangdu': '江都',
    'Guangling': '广陵',
    'Weiyang': '维扬',
    'Jingkou': '京口',
    'Runzhou': '润州',
    'Dantu': '丹徒',
    'Xinbei': '新北',
    'Tianning': '天宁',
    'Zhonglou': '钟楼',
    'Qishuyan': '戚墅堰',
    'Jintan': '金坛',
    'Liyang': '溧阳',
    'Wujin': '武进',

    // 国际主要城市
    'New York': '纽约',
    'Los Angeles': '洛杉矶',
    'Chicago': '芝加哥',
    'Houston': '休斯顿',
    'Philadelphia': '费城',
    'Phoenix': '菲尼克斯',
    'San Antonio': '圣安东尼奥',
    'San Diego': '圣地亚哥',
    'Dallas': '达拉斯',
    'San Jose': '圣何塞',
    'Austin': '奥斯汀',
    'Jacksonville': '杰克逊维尔',
    'San Francisco': '旧金山',
    'Columbus': '哥伦布',
    'Charlotte': '夏洛特',
    'Fort Worth': '沃思堡',
    'Indianapolis': '印第安纳波利斯',
    'Seattle': '西雅图',
    'Denver': '丹佛',
    'Washington': '华盛顿',
    'Boston': '波士顿',
    'El Paso': '埃尔帕索',
    'Detroit': '底特律',
    'Nashville': '纳什维尔',
    'Portland': '波特兰',
    'Memphis': '孟菲斯',
    'Oklahoma City': '俄克拉荷马城',
    'Las Vegas': '拉斯维加斯',
    'Louisville': '路易斯维尔',
    'Baltimore': '巴尔的摩',
    'Milwaukee': '密尔沃基',
    'Albuquerque': '阿尔伯克基',
    'Tucson': '图森',
    'Fresno': '弗雷斯诺',
    'Mesa': '梅萨',
    'Sacramento': '萨克拉门托',
    'Atlanta': '亚特兰大',
    'Kansas City': '堪萨斯城',
    'Colorado Springs': '科罗拉多斯普林斯',
    'Miami': '迈阿密',
    'Raleigh': '罗利',
    'Omaha': '奥马哈',
    'Long Beach': '长滩',
    'Virginia Beach': '弗吉尼亚海滩',
    'Oakland': '奥克兰',
    'Minneapolis': '明尼阿波利斯',
    'Tulsa': '塔尔萨',
    'Arlington': '阿灵顿',
    'Tampa': '坦帕',
    'New Orleans': '新奥尔良',
    'Wichita': '威奇托',
    'Cleveland': '克利夫兰',
    'Bakersfield': '贝克斯菲尔德',
    'Aurora': '奥罗拉',
    'Anaheim': '阿纳海姆',
    'Honolulu': '檀香山',
    'Santa Ana': '圣安娜',
    'Corpus Christi': '科珀斯克里斯蒂',
    'Riverside': '里弗赛德',
    'Lexington': '列克星敦',
    'Stockton': '斯托克顿',
    'Henderson': '亨德森',
    'Saint Paul': '圣保罗',
    'St. Louis': '圣路易斯',
    'Cincinnati': '辛辛那提',
    'Pittsburgh': '匹兹堡',
    // 其他国际城市
    'Tokyo': '东京',
    'Osaka': '大阪',
    'Yokohama': '横滨',
    'Nagoya': '名古屋',
    'Sapporo': '札幌',
    'Kobe': '神户',
    'Kyoto': '京都',
    'Fukuoka': '福冈',
    'Kawasaki': '川崎',
    'Saitama': '埼玉',
    'Hiroshima': '广岛',
    'Sendai': '仙台',
    'London': '伦敦',
    'Birmingham': '伯明翰',
    'Leeds': '利兹',
    'Glasgow': '格拉斯哥',
    'Sheffield': '谢菲尔德',
    'Bradford': '布拉德福德',
    'Liverpool': '利物浦',
    'Edinburgh': '爱丁堡',
    'Manchester': '曼彻斯特',
    'Bristol': '布里斯托',
    'Paris': '巴黎',
    'Marseille': '马赛',
    'Lyon': '里昂',
    'Toulouse': '图卢兹',
    'Nice': '尼斯',
    'Nantes': '南特',
    'Strasbourg': '斯特拉斯堡',
    'Montpellier': '蒙彼利埃',
    'Bordeaux': '波尔多',
    'Lille': '里尔',
    'Berlin': '柏林',
    'Hamburg': '汉堡',
    'Munich': '慕尼黑',
    'Cologne': '科隆',
    'Frankfurt': '法兰克福',
    'Stuttgart': '斯图加特',
    'Düsseldorf': '杜塞尔多夫',
    'Dortmund': '多特蒙德',
    'Essen': '埃森',
    'Leipzig': '莱比锡',
    'Bremen': '不来梅',
    'Dresden': '德累斯顿',
    'Hanover': '汉诺威',
    'Nuremberg': '纽伦堡',
    'Duisburg': '杜伊斯堡',
    'Seoul': '首尔',
    'Busan': '釜山',
    'Incheon': '仁川',
    'Daegu': '大邱',
    'Daejeon': '大田',
    'Gwangju': '光州',
    'Bangkok': '曼谷',
    'Sydney': '悉尼',
    'Melbourne': '墨尔本',
    'Brisbane': '布里斯班',
    'Perth': '珀斯',
    'Adelaide': '阿德莱德',
    'Toronto': '多伦多',
    'Montreal': '蒙特利尔',
    'Vancouver': '温哥华',
    'Calgary': '卡尔加里',
    'Edmonton': '埃德蒙顿',
    'Ottawa': '渥太华',
    'Winnipeg': '温尼伯',
    'Quebec City': '魁北克城',
    'Hamilton': '汉密尔顿',
    'Kitchener': '基奇纳',
    'Moscow': '莫斯科',
    'Saint Petersburg': '圣彼得堡',
    'Novosibirsk': '新西伯利亚',
    'Yekaterinburg': '叶卡捷琳堡',
    'Nizhny Novgorod': '下诺夫哥罗德',
    'Kazan': '喀山',
    'Chelyabinsk': '车里雅宾斯克',
    'Omsk': '鄂木斯克',
    'Samara': '萨马拉',
    'Rostov-on-Don': '顿河畔罗斯托夫',
    'Ufa': '乌法',
    'Krasnoyarsk': '克拉斯诺亚尔斯克',
    'Voronezh': '沃罗涅日',
    'Perm': '彼尔姆',
    'Volgograd': '伏尔加格勒'
};

// ISP名称映射
const ispNameMap = {
    'Google LLC': '谷歌公司',
    'Google': '谷歌',
    'Cloudflare, Inc.': '云闪网络公司',
    'Cloudflare': '云闪网络',
    'Amazon.com, Inc.': '亚马逊公司',
    'Amazon': '亚马逊',
    'Microsoft Corporation': '微软公司',
    'Microsoft': '微软',
    'China Telecom': '中国电信',
    'China Unicom': '中国联通',
    'China Mobile': '中国移动',
    'China Railcom': '中国铁通',
    'CERNET': '中国教育和科研计算机网',
    'CHINANET': '中国电信网',
    'ChinaUnicom': '中国联通',
    'ChinaMobile': '中国移动',
    'Beijing Baidu Netcom Science and Technology Co.': '北京百度网讯科技有限公司',
    'Baidu': '百度',
    'Alibaba': '阿里巴巴',
    'Tencent': '腾讯',
    'OpenDNS': '开放域名系统',
    'Level 3 Communications': '第三级通信',
    'Verizon': '威瑞森',
    'AT&T': '美国电话电报公司',
    'Comcast': '康卡斯特',
    'Charter Communications': '宪章通信',
    'Cox Communications': '考克斯通信',
    'Time Warner Cable': '时代华纳有线',
    'CenturyLink': '世纪链路',
    'Sprint': '斯普林特',
    'T-Mobile': 'T-移动',
    'Deutsche Telekom': '德国电信',
    'Orange': '橙色电信',
    'Vodafone': '沃达丰',
    'Telefonica': '西班牙电信',
    'British Telecom': '英国电信',
    'NTT': '日本电信电话',
    'KDDI': 'KDDI株式会社',
    'SoftBank': '软银',
    'Korea Telecom': '韩国电信',
    'SK Telecom': 'SK电信',
    'LG Uplus': 'LG U+',
    'Singtel': '新加坡电信',
    'Telstra': '澳洲电信',
    'Rogers': '罗杰斯通信',
    'Bell Canada': '贝尔加拿大',
    'Rostelecom': '俄罗斯电信'
};


/**
 * 将英文地名转换为中文
 * @param {string} englishName - 英文地名
 * @param {string} type - 地名类型 ('country', 'region', 'city')
 * @returns {string} 中文地名
 */
const translateToChineseName = (englishName, type = 'country') => {
    if (!englishName) return '';

    switch (type) {
        case 'country':
            return countryNameMap[englishName] || englishName;
        case 'region':
            // 如果是中国的省份，进行特殊处理
            return chinaProvinceMap[englishName] || englishName;
        case 'city':
            return cityNameMap[englishName] || englishName;
        default:
            return englishName;
    }
}

/**
 * 将ISP名称转换为中文
 * @param {string} ispName - ISP名称
 * @returns {string} 中文ISP名称
 */
const translateISPName = (ispName) => {
    if (!ispName) return '';
    return ispNameMap[ispName] || ispName;
}


/**
 * 转换IP信息格式化
 * @param {Object} ipResult - IP查询结果
 * @returns {Object} 转换后的数据对象
 */
const transformIPData = (ipResult) => {
    if (!ipResult.success) {
        // 查询失败的记录
        return {
            ip: ipResult.ip,
            country: '',
            province: '',
            city: '',
            area: '',
            isp: ''
        };
    }

    const data = ipResult.data || {};

    // 转换地理位置名称为中文
    const countryChina = translateToChineseName(data.country, 'country');
    const regionChina = translateToChineseName(data.region, 'region');
    const cityChina = translateToChineseName(data.city, 'city');

    return {
        ip: ipResult.ip,
        country: countryChina || '',
        province: regionChina || '',
        city: cityChina || '',
        area: '',
        isp: translateISPName(data.isp)
    };
}

/**
 * 查询IP地址的地理信息
 * @returns {Object} IP地理信息
 */
const getIPFromIPSB = async () => {
    const requestTime = new Date().toLocaleString('zh-CN');
    const startTime = Date.now();
    try {
        const endpoint = `https://api.ip.sb/geoip`;
        const data = await fetch(endpoint);
        const ipInfo = await data.json();
        const duration = Date.now() - startTime;

        const transformedData = transformIPData({
            success: true,
            ip: ipInfo.ip || '',
            data: ipInfo,
            queryTime: requestTime,
            duration: duration
        });
        return transformedData;

    } catch (error) {
        const errorTime = new Date().toLocaleString('zh-CN');
        return transformIPData({
            success: false,
            ip: '',
            error: error.message,
            httpStatus: error.status || '无',
            queryTime: errorTime,
            duration: Date.now() - startTime
        });
    }
}



export {
    getIPFromIPSB
}